<template>
    <div id="app" class="app fond">
         <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section class="Fiche">
                        <div class="Infos Contact">
                            <table class="Tableau-Fiche Contact">
                                <tbody>
                                    <tr>
                                        <th colspan="2" class="colspandeux"><h6>Accessibilité</h6></th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" class="logo-type-contact fill">
                                                <path id="Icon_material-place" data-name="Icon material-place" d="M18,3A10.492,10.492,0,0,0,7.5,13.5C7.5,21.375,18,33,18,33S28.5,21.375,28.5,13.5A10.492,10.492,0,0,0,18,3Zm0,14.25a3.75,3.75,0,1,1,3.75-3.75A3.751,3.751,0,0,1,18,17.25Z" transform="translate(-7.5 -3)"/>
                                            </svg>
                                        </th>
                                        <th>
                                            <a :href="Bibliotheque.acf.lien_adresse">{{Bibliotheque.acf.adresse}}</a>
                                            <br>
                                            <i>{{Bibliotheque.acf.complement_dadresse}}</i>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <iframe class="contenu-droit-page" :src="Bibliotheque.acf.lien_adresse_iframe" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </section>
                    <section class="Fiche">
                        <section class="Infos">                                
                            <h6>Contact</h6>
                            <div class="flex-Carte">
                                <br>
                                <div v-for="contact in Bibliotheque.acf.contact" :key="contact.ID" class="TableContactBiblio" style="display: flex">
                                    <div v-for="elu in listeElus" :key="elu.id" >
                                        <div v-if="elu.id == contact.ID" class="carte-conseiller">
                                            <div>
                                                <img :src="elu.image" class="portrait-conseiller" :alt="elu.nom">
                                            </div>

                                            <section class="contenu-carte">
                                                <h5>{{elu.prenom}} {{elu.nom}}</h5>
                                                <i v-for="role in elu.roles" :key="role.term_id">{{role.name}} <br> </i>
                                                <a :href="'tel:'+elu.telephone" v-if="elu.telephone != ''"><i>{{elu.telephone}}</i></a>
                                                <br v-if="elu.email != '' || elu.telephone != ''">
                                                <a :href="'mailto:'+elu.email" v-if="elu.email != ''"><i>{{elu.email}}</i></a>
                                            </section>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                        <div class="contenu-droit-page">
                            <img :src="Bibliotheque.acf.image.url" alt="Mairie de Quenne">
                        </div>
                    </section>
                    
                    <section class="Fiche">
                        <section class="Infos">
                            <table class="Tableau-Fiche">
                                <tbody>
                                    <tr>
                                        <th colspan="3" class="colspandeux"><h6>Tarifs</h6></th>
                                    </tr>
                                    <tr v-for="jour in Bibliotheque.acf.horaires.body" :key="jour.id">
                                        <th v-for="colonne in jour" :key="colonne.id">{{colonne.c}}</th>
                                    </tr>
                                    <tr>
                                        <th colspan="3" class="colspandeux"><p>{{Bibliotheque.acf.caution}}</p></th>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <div class="contenu-droit-page">
                            <iframe :src="Bibliotheque.acf.contrat" height="100%" width="100%"></iframe>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'SalleFete',
    data () {
        return{
            Bibliotheque:{
                id:0,
                acf:{
                    adresse: null,
                    complement_adresse: null,
                    lien_adresse: null,
                    lien_adresse_iframe: null,                
                    horaires:{},
                    image: {
                        id:0,
                        url:null
                    },
                    visuels: {},
                    logo:{},
                    contact: null,
                    contrat: null,
                    caution: null,
                }
            },
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeElus:{
                id:0,
                prenom:null,
                nom:null,
                roles:{
                    term_id: 0,
                    name: null
                },
                description:null,
                image:{}
            },
            avis:{
                titre_avis: null,
                date_loc: null,
                commentaire_avis: null
            }
        }
    }, 

    created(){
        axios.get(param.hostacf+'bibliotheque-nqd/29761')
        .then(response =>{
        this.Bibliotheque = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'elu/v1/listeElus')
        .then(response =>{
        this.listeElus = response.data;
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Cimetière'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },    
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Cimetiere.vue